import { Button } from 'antd';
import successImage from '../../assets/images/successBig.png';

const Success = ({
  buttonText,
  onClick,
  text,
  title,
}: {
  buttonText: string;
  onClick: () => void;
  text: string;
  title: string;
}) => {
  return (
    <div className="flex h-full flex-col items-center justify-center px-[16px]">
      <img className="mb-[24px]" src={successImage} alt="success" />
      <h1 className="mb-[24px] hidden text-center md:block">{title}</h1>
      <h2 className="mb-[24px] text-center md:hidden">{title}</h2>
      <p className="mb-[24px] text-center">{text}</p>
      <Button onClick={onClick} className="primary w-full md:w-fit">
        {buttonText}
      </Button>
    </div>
  );
};

export default Success;
